import {
  OneOfElements,
  OneOfPropertyElements,
} from '@shared/models/project.model';
import { cloneReplaceAt } from '@shared/helpers/array.helpers';
import {
  getElementProperties,
  isEditablePropertyName,
} from '../../element-property.helpers';
import { isOneOfPropertyElements } from '../../recursive-element.helpers';
import { validateElementProperty } from '@shared/validation/element-property.validation';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type PropertyRenameChange =
  ProjectChangeMap[ProjectChangeType.ElementPropertyRename];

/**
 * Build a partial element change for ElementPropertyRename.
 *
 * @param element - Current element state
 * @param change - Rename payload
 * @returns Partial with updated properties array, or undefined if the property cannot be renamed
 */
export const elementPropertyRenameToChange = (
  element: OneOfElements,
  change: PropertyRenameChange,
): Partial<OneOfPropertyElements> | undefined => {
  if (!isOneOfPropertyElements(element)) return undefined;

  const properties = getElementProperties(element);
  const index = properties.findIndex((p) => p.name === change.propertyName);
  const property = properties[index];
  if (
    !property ||
    property.name === change.name ||
    !isEditablePropertyName(property)
  ) {
    return undefined;
  }

  const updatedProperty = validateElementProperty({
    ...property,
    name: change.name,
  });

  return {
    properties: cloneReplaceAt(properties, index, updatedProperty),
  };
};
